import React from "react";
import useInspectionPrimaryLocationUpdate from "../../../../hooks/inspections/useInspectionPrimaryLocationUpdate";
import useInspectionAddressUpdate from "../../../../hooks/inspections/useInspectionAddressUpdate";
import StaffLocationTabChangeLocationModal, {
  ValidSubmitHandler,
} from "../../../staff/review/location/StaffLocationTabChangeLocationModal";
import useInspection from "../../../../hooks/inspections/useInspection";
import { PatchInspectionAddressReqBodyState } from "../../../../api/inspections/patchInspectionAddress";

interface InspectionStaffLocationTabChangeLocationModalProps {
  open: boolean;
  onClose: () => void;
  inspectionId: string | number;
  locationId?: number;
}
export default function InspectionStaffLocationTabChangeLocationModal({
  open,
  onClose,
  inspectionId,
  locationId,
}: InspectionStaffLocationTabChangeLocationModalProps) {
  const { inspectionQuery } = useInspection({ id: inspectionId });
  const address = inspectionQuery.data?.data.attributes.address;

  const { updateInspectionPrimaryLocation, isLoading: primaryLocationUpdateIsLoading } =
    useInspectionPrimaryLocationUpdate({
      id: inspectionId,
      onSuccess: onClose,
    });

  const { updateInspectionAddress, isLoading: addressUpdateIsLoading } = useInspectionAddressUpdate({
    id: inspectionId,
    onSuccess: onClose,
  });

  /**
   * Handle when the change-location modal submits.
   *
   *  1. If there is a primary-location, prioritize updating the inspection's primary-location
   *  2. If there is no primary-location, and the address is present, update the address
   *
   * In all other cases, do nothing.
   *
   * @param param0
   */
  const handleValidSubmit: ValidSubmitHandler = ({ location, address }) => {
    if (location) {
      updateInspectionPrimaryLocation({
        data: {
          primaryLocationId: location?.id,
        },
      });
    } else if (address) {
      updateInspectionAddress({
        data: {
          address: {
            attn: address.attn ?? undefined,
            address: address.address,
            address2: address.address2 ?? undefined,
            city: address.city,
            state: address.state as PatchInspectionAddressReqBodyState,
            zip: address.zip,
            countryId: address.countryId,
          },
        },
      });
    }
  };

  const isLoading = primaryLocationUpdateIsLoading || addressUpdateIsLoading;

  return (
    <StaffLocationTabChangeLocationModal
      open={open}
      onClose={onClose}
      onValidSubmit={handleValidSubmit}
      isLoading={isLoading}
      defaultAddress={address}
      defaultLocationId={locationId}
      allowEnterManually={true}
    />
  );
}
